import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiHserviceElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiHserviceElFindParams, unknown>

const fetchHServiceList = async (params: ApiHserviceElFindParams) => {
  const { data } = await apiClient.v2.apiHserviceElFind(params);
  return checkApiResponse(data);
}

export const hserviceKeys = {
  all: [QUERY_KEY.v2apiHserviceElFind] as const,
  list: (params: ApiHserviceElFindParams) => [...hserviceKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(hserviceFindQueryOptions(params))` */
export const hserviceFindQueryOptions = (params: ApiHserviceElFindParams) => ({
  queryKey: hserviceKeys.list(params),
  queryFn: () => fetchHServiceList(params),
})

export const useHServiceFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: hserviceKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchHServiceList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
